import { useState, type FormEvent } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/da2keb2amq5jpe1hruvg";

export default function Contact() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const honeypot = (data.get("website_alt") as string) || "";
    if (honeypot.trim()) {
      setStatus("success");
      setMessage("订阅成功，感谢你的关注！");
      form.reset();
      return;
    }

    data.delete("website_alt");

    try {
      const payload = new URLSearchParams();
      data.forEach((value, key) => {
        payload.append(key, value as string);
      });

      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });

      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (res.ok && parsed?.code === "OK") {
        setStatus("success");
        setMessage("订阅成功，搞笑合集马上送到你邮箱！");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "订阅失败，请稍后再试");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后再试");
    }
  };

  return (
    <section id="contact" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-700">
              <i className="ri-mail-send-line"></i> 联系我们
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
              一起找乐子，也欢迎投稿
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              你有沙雕日常想分享？你有神吐槽不吐不快？欢迎留言或投稿。
              订阅更新后，我们会定期把新鲜合集推送到你身边。
            </p>

            <div className="mt-7 space-y-4">
              <div className="flex items-center gap-3">
                <span className="grid h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-xl text-accent-600">
                  <i className="ri-mail-line"></i>
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-900">投稿与合作</div>
                  <div className="text-sm text-foreground-600">hello@waiwaicomics.cn</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="grid h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-xl text-secondary-900">
                  <i className="ri-time-line"></i>
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-900">内容更新</div>
                  <div className="text-sm text-foreground-600">每日更新，无厘头剧情持续上新</div>
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-2xl border border-background-200 bg-background-100/60 p-6 md:p-8">
            <h3 className="font-heading text-xl text-foreground-950">订阅搞笑合集</h3>
            <p className="mt-1.5 text-sm text-foreground-600">
              留下邮箱，第一时间收到新鲜沙雕与神吐槽。
            </p>

            <form data-readdy-form onSubmit={handleSubmit} className="mt-6 space-y-4">
              <div className="space-y-1.5">
                <label htmlFor="email" className="text-sm text-foreground-700">
                  邮箱地址
                </label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  required
                  placeholder="you@example.com"
                  className="w-full rounded-lg border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
                />
              </div>

              <div className="contact-hidden-trap" aria-hidden="true">
                <label>
                  网站备用字段
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    readOnly
                  />
                </label>
              </div>

              <button
                type="submit"
                className="w-full whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                订阅更新
              </button>

              {status !== "idle" && (
                <div
                  className={`flex items-start gap-2 rounded-lg px-4 py-3 text-sm ${
                    status === "success"
                      ? "bg-primary-100 text-primary-800"
                      : "bg-accent-100 text-accent-800"
                  }`}
                >
                  <i
                    className={`${status === "success" ? "ri-checkbox-circle-fill" : "ri-error-warning-fill"} mt-0.5`}
                  ></i>
                  <span>{message}</span>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}